export default __webpack_public_path__ + "static/media/cafeshow_throo08.d237cd88.png";